import styled from 'styled-components';

const col =
    '[page-start sidebar-start] auto [sidebar-end controls-start] auto [controls-end] minmax(591px,1fr) [instrument-start] auto [instrument-end page-end]';

const MapAreaGrid = styled.div`
    pointer-events: none;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    display: grid;
    grid-template-columns: ${col};
    grid-template-rows: [top error-bar-top] auto [error-bar-bottom] 300px 1fr [toast-top] 50px [toast-bottom segment-details-top] auto [segment-details-bottom timeline-top] auto [timeline-bottom bottom];
`;

export default MapAreaGrid;
